export default "__VITE_ASSET__5e9f7801__"